export default defineNuxtRouteMiddleware((to, from) => {
  // Redirect from /old-route to /new-route
  if (to.path === '/rozowa-wstazka') {
    return navigateTo('/akcje-profilaktyczne/rozowa-wstazka')
  }
  if (to.path === '/wlasny-zestaw-badan') {
    return navigateTo('/katalog-badan/badania')
  }
  if (to.path === '/katalog-badan/pakiet-wlasny') {
    return navigateTo('/katalog-badan/badania')
  }
  if (to.path === '/regulamin') {
    return navigateTo('/static/regulamin')
  }
  if (to.path === '/contact/faktura') {
    return navigateTo('/')
  }
  if (to.path === '/reklamacje') {
    return navigateTo('https://alabreklamacje.pl', { external: true })
  }
})
